import { render, staticRenderFns } from "./PaymentMethodCard.vue?vue&type=template&id=63848bde&scoped=true"
import script from "./PaymentMethodCard.vue?vue&type=script&lang=js"
export * from "./PaymentMethodCard.vue?vue&type=script&lang=js"
import style0 from "./PaymentMethodCard.vue?vue&type=style&index=0&id=63848bde&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63848bde",
  null
  
)

export default component.exports